import { render, staticRenderFns } from "./CustomerCustomerEmailTemplate.vue?vue&type=template&id=49afa396&scoped=true"
import script from "./CustomerCustomerEmailTemplate.vue?vue&type=script&lang=js"
export * from "./CustomerCustomerEmailTemplate.vue?vue&type=script&lang=js"
import style0 from "./CustomerCustomerEmailTemplate.vue?vue&type=style&index=0&id=49afa396&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49afa396",
  null
  
)

export default component.exports